/* eslint-disable */
/* This file is auto-generated by scripts/generate-dashboard-types.js */
/* Do not edit manually — regenerate with: yarn generate-dashboard-types */

import type { ContentCardComponent, DashboardComponent, PieChartComponent } from './dashboardDefinition';

/** Numeric metrics — the vocabulary for `metrics`, `series`, and every numeric `metric` field. */
export const DASHBOARD_NUMERIC_METRICS = [
  'accounts_payable',
  'accounts_receivables',
  'accrued_liabilities',
  'adjusted_ebitda',
  'adjusted_ebitda_margin',
  'amortization_expense',
  'avg_option_strike_price',
  'avg_warrant_strike_price',
  'breakeven_exit_equity_value',
  'bs_equity',
  'cash_and_equivalents',
  'cash_distributions',
  'common_share_value',
  'company_count',
  'cost_of_sales_percent',
  'current_fund_value',
  'dcf_discount_rate',
  'deferred_revenue',
  'depreciation_expense',
  'diluted_ownership',
  'ebit',
  'ebitda',
  'ebitda_margin',
  'enterprise_value',
  'equity_value',
  'fund_cost_basis',
  'fund_cse_shares',
  'fund_preference',
  'fund_shares',
  'gross_irr',
  'gross_margin',
  'gross_profit',
  'highest_breakpoint_limit',
  'highest_breakpoint_price',
  'implied_arr_multiple',
  'implied_ev_kpi',
  'implied_ev_ltm_ebitda',
  'implied_ev_ltm_revenue',
  'implied_ev_ntm_ebitda',
  'implied_ev_ntm_revenue',
  'income_taxes',
  'initial_note_conversion_price',
  'initial_note_expected_shares',
  'intangibles',
  'interest_expense',
  'inventory',
  'invested_capital',
  'loan_value',
  'long_term_debt',
  'moic',
  'net_cash_flows',
  'net_income',
  'net_profit_margin',
  'ntm_adjusted_ebitda',
  'ntm_adjusted_ebitda_margin',
  'ntm_amortization_expense',
  'ntm_cost_of_sales_percent',
  'ntm_depreciation_expense',
  'ntm_ebit',
  'ntm_ebitda',
  'ntm_ebitda_margin',
  'ntm_gross_margin',
  'ntm_gross_profit',
  'ntm_income_taxes',
  'ntm_interest_expense',
  'ntm_net_income',
  'ntm_net_profit_margin',
  'ntm_operating_expenses',
  'ntm_operating_percent_of_sales',
  'ntm_other_expense',
  'ntm_pretax_income',
  'ntm_revenue_growth_rate',
  'ntm_total_cost_of_sales',
  'ntm_total_revenue',
  'operating_expenses',
  'operating_percent_of_sales',
  'option_pool_percent',
  'other_current_assets',
  'other_current_liabilities',
  'other_expense',
  'other_long_term_assets',
  'other_long_term_debt',
  'outstanding_ownership',
  'pending_document_requests',
  'pending_questions',
  'percent_change_from_previous',
  'ppe',
  'pretax_income',
  'proceeds_from_shares_sold',
  'projected_revenue_year_1',
  'projected_revenue_year_2',
  'projected_revenue_year_3',
  'realized_value',
  'referenced_documents',
  'revenue_growth_rate',
  'short_term_debt',
  'specific_preference',
  'total_assets',
  'total_common_shares',
  'total_company_preference',
  'total_cost_of_sales',
  'total_current_assets',
  'total_current_liabilities',
  'total_documents',
  'total_fully_diluted_preferred_shares',
  'total_fully_diluted_shares',
  'total_initial_liquidation_preference',
  'total_insight_preference',
  'total_liabilities',
  'total_liabilities_and_equity',
  'total_long_term_assets',
  'total_long_term_debt',
  'total_note_expected_shares',
  'total_options',
  'total_other_capital_costs',
  'total_outstanding_preferred_shares',
  'total_outstanding_shares',
  'total_preference_with_dividends',
  'total_preferred_rounds',
  'total_raised',
  'total_revenue',
  'total_unissued_options',
  'total_value',
  'total_warrants',
  'unrealized_value',
] as const satisfies readonly PieChartComponent['fields']['metric'][];

/** Chart dimensions — every summary column plus the schema-only axes `measurement_date` and `financial_period`. */
export const DASHBOARD_DIMENSIONS = [
  'accounts_payable',
  'accounts_receivables',
  'accrued_liabilities',
  'adjusted_ebitda',
  'adjusted_ebitda_margin',
  'allocation_method',
  'amortization_expense',
  'avg_option_strike_price',
  'avg_warrant_strike_price',
  'balance_sheet_date',
  'breakeven_exit_equity_value',
  'bs_equity',
  'cap_table_currency',
  'cap_table_version_name',
  'cash_and_equivalents',
  'cash_distributions',
  'common_share_value',
  'company_count',
  'company_name',
  'cost_of_sales_percent',
  'current_fund_value',
  'dcf_discount_rate',
  'deferred_revenue',
  'depreciation_expense',
  'diluted_ownership',
  'ebit',
  'ebitda',
  'ebitda_margin',
  'enterprise_valuation_method',
  'enterprise_value',
  'equity_value',
  'financial_period',
  'financials_currency',
  'financials_date',
  'fiscal_year_end',
  'fund_cost_basis',
  'fund_cse_shares',
  'fund_name',
  'fund_preference',
  'fund_shares',
  'gross_irr',
  'gross_margin',
  'gross_profit',
  'highest_breakpoint_limit',
  'highest_breakpoint_price',
  'implied_arr_multiple',
  'implied_ev_kpi',
  'implied_ev_ltm_ebitda',
  'implied_ev_ltm_revenue',
  'implied_ev_ntm_ebitda',
  'implied_ev_ntm_revenue',
  'income_taxes',
  'initial_investment_date',
  'initial_note_conversion_model',
  'initial_note_conversion_price',
  'initial_note_expected_shares',
  'initial_note_issuance_date',
  'initial_round_date',
  'intangibles',
  'interest_expense',
  'inventory',
  'invested_capital',
  'last_finalized_at',
  'loan_value',
  'long_term_debt',
  'ltm_date',
  'measurement_date',
  'moic',
  'most_recent_investment_date',
  'most_recent_round_date',
  'net_cash_flows',
  'net_income',
  'net_profit_margin',
  'ntm_adjusted_ebitda',
  'ntm_adjusted_ebitda_margin',
  'ntm_amortization_expense',
  'ntm_cost_of_sales_percent',
  'ntm_date',
  'ntm_depreciation_expense',
  'ntm_ebit',
  'ntm_ebitda',
  'ntm_ebitda_margin',
  'ntm_gross_margin',
  'ntm_gross_profit',
  'ntm_income_taxes',
  'ntm_interest_expense',
  'ntm_net_income',
  'ntm_net_profit_margin',
  'ntm_operating_expenses',
  'ntm_operating_percent_of_sales',
  'ntm_other_expense',
  'ntm_pretax_income',
  'ntm_revenue_growth_rate',
  'ntm_total_cost_of_sales',
  'ntm_total_revenue',
  'operating_expenses',
  'operating_percent_of_sales',
  'option_pool_percent',
  'other_current_assets',
  'other_current_liabilities',
  'other_expense',
  'other_long_term_assets',
  'other_long_term_debt',
  'outstanding_ownership',
  'pending_document_requests',
  'pending_questions',
  'percent_change_from_previous',
  'ppe',
  'pretax_income',
  'proceeds_from_shares_sold',
  'projected_revenue_year_1',
  'projected_revenue_year_2',
  'projected_revenue_year_3',
  'realized_value',
  'referenced_documents',
  'revenue_growth_rate',
  'short_term_debt',
  'specific_preference',
  'total_assets',
  'total_common_shares',
  'total_company_preference',
  'total_cost_of_sales',
  'total_current_assets',
  'total_current_liabilities',
  'total_documents',
  'total_fully_diluted_preferred_shares',
  'total_fully_diluted_shares',
  'total_initial_liquidation_preference',
  'total_insight_preference',
  'total_liabilities',
  'total_liabilities_and_equity',
  'total_long_term_assets',
  'total_long_term_debt',
  'total_note_expected_shares',
  'total_options',
  'total_other_capital_costs',
  'total_outstanding_preferred_shares',
  'total_outstanding_shares',
  'total_preference_with_dividends',
  'total_preferred_rounds',
  'total_raised',
  'total_revenue',
  'total_unissued_options',
  'total_value',
  'total_warrants',
  'unrealized_value',
  'uses_custom_breakpoints',
  'valuation_approach',
  'valuation_is_final',
  'valuation_is_published',
  'valuation_methods',
  'valuation_status',
] as const satisfies readonly PieChartComponent['fields']['dimension'][];

/** Full column vocabulary — also what a `table` component's column values are validated against. */
export const DASHBOARD_COLUMN_VOCABULARY = [
  'accounts_payable',
  'accounts_receivables',
  'accrued_liabilities',
  'adjusted_ebitda',
  'adjusted_ebitda_margin',
  'allocation_method',
  'amortization_expense',
  'avg_option_strike_price',
  'avg_warrant_strike_price',
  'balance_sheet_date',
  'breakeven_exit_equity_value',
  'bs_equity',
  'cap_table_currency',
  'cap_table_version_name',
  'cash_and_equivalents',
  'cash_distributions',
  'common_share_value',
  'company_count',
  'company_name',
  'cost_of_sales_percent',
  'current_fund_value',
  'dcf_discount_rate',
  'deferred_revenue',
  'depreciation_expense',
  'diluted_ownership',
  'ebit',
  'ebitda',
  'ebitda_margin',
  'enterprise_valuation_method',
  'enterprise_value',
  'equity_value',
  'financials_currency',
  'financials_date',
  'fiscal_year_end',
  'fund_cost_basis',
  'fund_cse_shares',
  'fund_name',
  'fund_preference',
  'fund_shares',
  'gross_irr',
  'gross_margin',
  'gross_profit',
  'highest_breakpoint_limit',
  'highest_breakpoint_price',
  'implied_arr_multiple',
  'implied_ev_kpi',
  'implied_ev_ltm_ebitda',
  'implied_ev_ltm_revenue',
  'implied_ev_ntm_ebitda',
  'implied_ev_ntm_revenue',
  'income_taxes',
  'initial_investment_date',
  'initial_note_conversion_model',
  'initial_note_conversion_price',
  'initial_note_expected_shares',
  'initial_note_issuance_date',
  'initial_round_date',
  'intangibles',
  'interest_expense',
  'inventory',
  'invested_capital',
  'last_finalized_at',
  'loan_value',
  'long_term_debt',
  'ltm_date',
  'moic',
  'most_recent_investment_date',
  'most_recent_round_date',
  'net_cash_flows',
  'net_income',
  'net_profit_margin',
  'ntm_adjusted_ebitda',
  'ntm_adjusted_ebitda_margin',
  'ntm_amortization_expense',
  'ntm_cost_of_sales_percent',
  'ntm_date',
  'ntm_depreciation_expense',
  'ntm_ebit',
  'ntm_ebitda',
  'ntm_ebitda_margin',
  'ntm_gross_margin',
  'ntm_gross_profit',
  'ntm_income_taxes',
  'ntm_interest_expense',
  'ntm_net_income',
  'ntm_net_profit_margin',
  'ntm_operating_expenses',
  'ntm_operating_percent_of_sales',
  'ntm_other_expense',
  'ntm_pretax_income',
  'ntm_revenue_growth_rate',
  'ntm_total_cost_of_sales',
  'ntm_total_revenue',
  'operating_expenses',
  'operating_percent_of_sales',
  'option_pool_percent',
  'other_current_assets',
  'other_current_liabilities',
  'other_expense',
  'other_long_term_assets',
  'other_long_term_debt',
  'outstanding_ownership',
  'pending_document_requests',
  'pending_questions',
  'percent_change_from_previous',
  'ppe',
  'pretax_income',
  'proceeds_from_shares_sold',
  'projected_revenue_year_1',
  'projected_revenue_year_2',
  'projected_revenue_year_3',
  'realized_value',
  'referenced_documents',
  'revenue_growth_rate',
  'short_term_debt',
  'specific_preference',
  'total_assets',
  'total_common_shares',
  'total_company_preference',
  'total_cost_of_sales',
  'total_current_assets',
  'total_current_liabilities',
  'total_documents',
  'total_fully_diluted_preferred_shares',
  'total_fully_diluted_shares',
  'total_initial_liquidation_preference',
  'total_insight_preference',
  'total_liabilities',
  'total_liabilities_and_equity',
  'total_long_term_assets',
  'total_long_term_debt',
  'total_note_expected_shares',
  'total_options',
  'total_other_capital_costs',
  'total_outstanding_preferred_shares',
  'total_outstanding_shares',
  'total_preference_with_dividends',
  'total_preferred_rounds',
  'total_raised',
  'total_revenue',
  'total_unissued_options',
  'total_value',
  'total_warrants',
  'unrealized_value',
  'uses_custom_breakpoints',
  'valuation_approach',
  'valuation_is_final',
  'valuation_is_published',
  'valuation_methods',
  'valuation_status',
] as const satisfies readonly NonNullable<NonNullable<ContentCardComponent['fields']>['metric']>[];

/** Registered component types, in registry declaration order. */
export const DASHBOARD_COMPONENT_TYPES = [
  'totals',
  'bar_chart',
  'line_chart',
  'pie_chart',
  'table',
  'content_card',
  'list',
] as const satisfies readonly DashboardComponent['type'][];

export type DashboardMetricRole = 'measure' | 'dimension' | 'column';

export interface DashboardMetricSlotCompatibility {
  /** Component types that can use this column in this slot. */
  compatible: readonly DashboardComponent['type'][];
  /** Component types that cannot, keyed to a DASHBOARD_COMPATIBILITY_REASONS code. */
  incompatible: Readonly<Record<string, string>>;
}

export interface DashboardMetricCatalogEntry {
  /** Snapshot bucket the column comes from, or `axis` for the schema-only axes. */
  category: string;
  category_label: string;
  compatibility: Readonly<Record<DashboardMetricRole, DashboardMetricSlotCompatibility>>;
  /** Default number format; absent for non-numeric columns. */
  format_hint?: string;
  kind: string;
  /** Stored as 42.0 for 42%, not 0.42 — a percent formatter must not scale it again. */
  percent_scaled?: boolean;
}

/** Per-column field catalog: category, unit, and which component types each slot role suits. ADVISORY — the backend validator still accepts any metric in the vocabulary, so an incompatible option is disabled and explained, never removed. */
export const DASHBOARD_METRIC_CATALOG: Record<PieChartComponent['fields']['dimension'], DashboardMetricCatalogEntry> = {
  accounts_payable: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  accounts_receivables: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  accrued_liabilities: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  adjusted_ebitda: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  adjusted_ebitda_margin: {
    kind: 'percent',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'content_card', 'list'],
        incompatible: {
          pie_chart: 'not_additive_pie',
        },
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'percent',
    percent_scaled: true,
  },
  allocation_method: {
    kind: 'list',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'multi_valued_dimension',
          line_chart: 'multi_valued_dimension',
          pie_chart: 'multi_valued_dimension',
        },
      },
      measure: {
        compatible: ['content_card'],
        incompatible: {
          bar_chart: 'not_numeric_list',
          line_chart: 'not_numeric_list',
          list: 'not_numeric_list',
          pie_chart: 'not_numeric_list',
          totals: 'not_numeric_list',
        },
      },
    },
    category: 'valuation_allocation',
    category_label: 'Valuation & Allocation',
  },
  amortization_expense: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  avg_option_strike_price: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['content_card', 'list'],
        incompatible: {
          bar_chart: 'no_firm_total',
          line_chart: 'no_firm_total',
          pie_chart: 'no_firm_total',
          totals: 'no_firm_total',
        },
      },
    },
    category: 'cap_table',
    category_label: 'Cap Table',
    format_hint: 'currency',
  },
  avg_warrant_strike_price: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['content_card', 'list'],
        incompatible: {
          bar_chart: 'no_firm_total',
          line_chart: 'no_firm_total',
          pie_chart: 'no_firm_total',
          totals: 'no_firm_total',
        },
      },
    },
    category: 'cap_table',
    category_label: 'Cap Table',
    format_hint: 'currency',
  },
  balance_sheet_date: {
    kind: 'date',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: ['bar_chart', 'line_chart', 'pie_chart'],
        incompatible: {},
      },
      measure: {
        compatible: ['content_card'],
        incompatible: {
          bar_chart: 'not_numeric_date',
          line_chart: 'not_numeric_date',
          list: 'not_numeric_date',
          pie_chart: 'not_numeric_date',
          totals: 'not_numeric_date',
        },
      },
    },
    category: 'financials',
    category_label: 'Financials',
  },
  breakeven_exit_equity_value: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'valuation_allocation',
    category_label: 'Valuation & Allocation',
    format_hint: 'currency',
  },
  bs_equity: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  cap_table_currency: {
    kind: 'text',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: ['bar_chart', 'pie_chart'],
        incompatible: {
          line_chart: 'unordered_axis_line',
        },
      },
      measure: {
        compatible: ['content_card'],
        incompatible: {
          bar_chart: 'not_numeric_text',
          line_chart: 'not_numeric_text',
          list: 'not_numeric_text',
          pie_chart: 'not_numeric_text',
          totals: 'not_numeric_text',
        },
      },
    },
    category: 'cap_table',
    category_label: 'Cap Table',
  },
  cap_table_version_name: {
    kind: 'text',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: ['bar_chart', 'pie_chart'],
        incompatible: {
          line_chart: 'unordered_axis_line',
        },
      },
      measure: {
        compatible: ['content_card'],
        incompatible: {
          bar_chart: 'not_numeric_text',
          line_chart: 'not_numeric_text',
          list: 'not_numeric_text',
          pie_chart: 'not_numeric_text',
          totals: 'not_numeric_text',
        },
      },
    },
    category: 'cap_table',
    category_label: 'Cap Table',
  },
  cash_and_equivalents: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  cash_distributions: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'ownership',
    category_label: 'Ownership',
    format_hint: 'currency',
  },
  common_share_value: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['content_card', 'list'],
        incompatible: {
          bar_chart: 'no_firm_total',
          line_chart: 'no_firm_total',
          pie_chart: 'no_firm_total',
          totals: 'no_firm_total',
        },
      },
    },
    category: 'valuation_allocation',
    category_label: 'Valuation & Allocation',
    format_hint: 'currency',
  },
  company_count: {
    kind: 'count',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['content_card', 'list'],
        incompatible: {
          bar_chart: 'no_firm_total',
          line_chart: 'no_firm_total',
          pie_chart: 'no_firm_total',
          totals: 'no_firm_total',
        },
      },
    },
    category: 'cap_table',
    category_label: 'Cap Table',
    format_hint: 'integer',
  },
  company_name: {
    kind: 'text',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: ['bar_chart', 'pie_chart'],
        incompatible: {
          line_chart: 'unordered_axis_line',
        },
      },
      measure: {
        compatible: ['content_card'],
        incompatible: {
          bar_chart: 'not_numeric_text',
          line_chart: 'not_numeric_text',
          list: 'not_numeric_text',
          pie_chart: 'not_numeric_text',
          totals: 'not_numeric_text',
        },
      },
    },
    category: 'identity',
    category_label: 'Identity',
  },
  cost_of_sales_percent: {
    kind: 'percent',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'content_card', 'list'],
        incompatible: {
          pie_chart: 'not_additive_pie',
        },
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'percent',
    percent_scaled: true,
  },
  current_fund_value: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'valuation_allocation',
    category_label: 'Valuation & Allocation',
    format_hint: 'currency',
  },
  dcf_discount_rate: {
    kind: 'percent',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'content_card', 'list'],
        incompatible: {
          pie_chart: 'not_additive_pie',
        },
      },
    },
    category: 'valuation_allocation',
    category_label: 'Valuation & Allocation',
    format_hint: 'percent',
  },
  deferred_revenue: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  depreciation_expense: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  diluted_ownership: {
    kind: 'percent',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'content_card', 'list'],
        incompatible: {
          pie_chart: 'not_additive_pie',
        },
      },
    },
    category: 'ownership',
    category_label: 'Ownership',
    format_hint: 'percent',
  },
  ebit: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  ebitda: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  ebitda_margin: {
    kind: 'percent',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'content_card', 'list'],
        incompatible: {
          pie_chart: 'not_additive_pie',
        },
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'percent',
    percent_scaled: true,
  },
  enterprise_valuation_method: {
    kind: 'text',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: ['bar_chart', 'pie_chart'],
        incompatible: {
          line_chart: 'unordered_axis_line',
        },
      },
      measure: {
        compatible: ['content_card'],
        incompatible: {
          bar_chart: 'not_numeric_text',
          line_chart: 'not_numeric_text',
          list: 'not_numeric_text',
          pie_chart: 'not_numeric_text',
          totals: 'not_numeric_text',
        },
      },
    },
    category: 'valuation_allocation',
    category_label: 'Valuation & Allocation',
  },
  enterprise_value: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'valuation_allocation',
    category_label: 'Valuation & Allocation',
    format_hint: 'currency',
  },
  equity_value: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'valuation_allocation',
    category_label: 'Valuation & Allocation',
    format_hint: 'currency',
  },
  financial_period: {
    kind: 'text',
    compatibility: {
      column: {
        compatible: [],
        incompatible: {
          table: 'axis_only',
        },
      },
      dimension: {
        compatible: ['bar_chart', 'line_chart', 'pie_chart'],
        incompatible: {},
      },
      measure: {
        compatible: [],
        incompatible: {
          bar_chart: 'axis_only',
          content_card: 'axis_only',
          line_chart: 'axis_only',
          list: 'axis_only',
          pie_chart: 'axis_only',
          totals: 'axis_only',
        },
      },
    },
    category: 'axis',
    category_label: 'Chart Axes',
  },
  financials_currency: {
    kind: 'text',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: ['bar_chart', 'pie_chart'],
        incompatible: {
          line_chart: 'unordered_axis_line',
        },
      },
      measure: {
        compatible: ['content_card'],
        incompatible: {
          bar_chart: 'not_numeric_text',
          line_chart: 'not_numeric_text',
          list: 'not_numeric_text',
          pie_chart: 'not_numeric_text',
          totals: 'not_numeric_text',
        },
      },
    },
    category: 'financials',
    category_label: 'Financials',
  },
  financials_date: {
    kind: 'date',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: ['bar_chart', 'line_chart', 'pie_chart'],
        incompatible: {},
      },
      measure: {
        compatible: ['content_card'],
        incompatible: {
          bar_chart: 'not_numeric_date',
          line_chart: 'not_numeric_date',
          list: 'not_numeric_date',
          pie_chart: 'not_numeric_date',
          totals: 'not_numeric_date',
        },
      },
    },
    category: 'financials',
    category_label: 'Financials',
  },
  fiscal_year_end: {
    kind: 'date',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: ['bar_chart', 'line_chart', 'pie_chart'],
        incompatible: {},
      },
      measure: {
        compatible: ['content_card'],
        incompatible: {
          bar_chart: 'not_numeric_date',
          line_chart: 'not_numeric_date',
          list: 'not_numeric_date',
          pie_chart: 'not_numeric_date',
          totals: 'not_numeric_date',
        },
      },
    },
    category: 'financials',
    category_label: 'Financials',
  },
  fund_cost_basis: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'ownership',
    category_label: 'Ownership',
    format_hint: 'currency',
  },
  fund_cse_shares: {
    kind: 'count',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'ownership',
    category_label: 'Ownership',
    format_hint: 'integer',
  },
  fund_name: {
    kind: 'text',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: ['bar_chart', 'pie_chart'],
        incompatible: {
          line_chart: 'unordered_axis_line',
        },
      },
      measure: {
        compatible: ['content_card'],
        incompatible: {
          bar_chart: 'not_numeric_text',
          line_chart: 'not_numeric_text',
          list: 'not_numeric_text',
          pie_chart: 'not_numeric_text',
          totals: 'not_numeric_text',
        },
      },
    },
    category: 'identity',
    category_label: 'Identity',
  },
  fund_preference: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'ownership',
    category_label: 'Ownership',
    format_hint: 'currency',
  },
  fund_shares: {
    kind: 'count',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'ownership',
    category_label: 'Ownership',
    format_hint: 'integer',
  },
  gross_irr: {
    kind: 'percent',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'content_card', 'list'],
        incompatible: {
          pie_chart: 'not_additive_pie',
        },
      },
    },
    category: 'cash_flows',
    category_label: 'Cash Flows',
    format_hint: 'percent',
  },
  gross_margin: {
    kind: 'percent',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'content_card', 'list'],
        incompatible: {
          pie_chart: 'not_additive_pie',
        },
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'percent',
    percent_scaled: true,
  },
  gross_profit: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  highest_breakpoint_limit: {
    kind: 'count',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['content_card', 'list'],
        incompatible: {
          bar_chart: 'no_firm_total',
          line_chart: 'no_firm_total',
          pie_chart: 'no_firm_total',
          totals: 'no_firm_total',
        },
      },
    },
    category: 'breakpoints',
    category_label: 'Breakpoints',
    format_hint: 'integer',
  },
  highest_breakpoint_price: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['content_card', 'list'],
        incompatible: {
          bar_chart: 'no_firm_total',
          line_chart: 'no_firm_total',
          pie_chart: 'no_firm_total',
          totals: 'no_firm_total',
        },
      },
    },
    category: 'breakpoints',
    category_label: 'Breakpoints',
    format_hint: 'currency',
  },
  implied_arr_multiple: {
    kind: 'multiple',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'content_card', 'list'],
        incompatible: {
          pie_chart: 'not_additive_pie',
        },
      },
    },
    category: 'valuation_allocation',
    category_label: 'Valuation & Allocation',
    format_hint: 'multiplier',
  },
  implied_ev_kpi: {
    kind: 'multiple',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['content_card', 'list'],
        incompatible: {
          bar_chart: 'no_firm_total',
          line_chart: 'no_firm_total',
          pie_chart: 'no_firm_total',
          totals: 'no_firm_total',
        },
      },
    },
    category: 'valuation_allocation',
    category_label: 'Valuation & Allocation',
    format_hint: 'multiplier',
  },
  implied_ev_ltm_ebitda: {
    kind: 'multiple',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'content_card', 'list'],
        incompatible: {
          pie_chart: 'not_additive_pie',
        },
      },
    },
    category: 'valuation_allocation',
    category_label: 'Valuation & Allocation',
    format_hint: 'multiplier',
  },
  implied_ev_ltm_revenue: {
    kind: 'multiple',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'content_card', 'list'],
        incompatible: {
          pie_chart: 'not_additive_pie',
        },
      },
    },
    category: 'valuation_allocation',
    category_label: 'Valuation & Allocation',
    format_hint: 'multiplier',
  },
  implied_ev_ntm_ebitda: {
    kind: 'multiple',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'content_card', 'list'],
        incompatible: {
          pie_chart: 'not_additive_pie',
        },
      },
    },
    category: 'valuation_allocation',
    category_label: 'Valuation & Allocation',
    format_hint: 'multiplier',
  },
  implied_ev_ntm_revenue: {
    kind: 'multiple',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'content_card', 'list'],
        incompatible: {
          pie_chart: 'not_additive_pie',
        },
      },
    },
    category: 'valuation_allocation',
    category_label: 'Valuation & Allocation',
    format_hint: 'multiplier',
  },
  income_taxes: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  initial_investment_date: {
    kind: 'date',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: ['bar_chart', 'line_chart', 'pie_chart'],
        incompatible: {},
      },
      measure: {
        compatible: ['content_card'],
        incompatible: {
          bar_chart: 'not_numeric_date',
          line_chart: 'not_numeric_date',
          list: 'not_numeric_date',
          pie_chart: 'not_numeric_date',
          totals: 'not_numeric_date',
        },
      },
    },
    category: 'ownership',
    category_label: 'Ownership',
  },
  initial_note_conversion_model: {
    kind: 'text',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: ['bar_chart', 'pie_chart'],
        incompatible: {
          line_chart: 'unordered_axis_line',
        },
      },
      measure: {
        compatible: ['content_card'],
        incompatible: {
          bar_chart: 'not_numeric_text',
          line_chart: 'not_numeric_text',
          list: 'not_numeric_text',
          pie_chart: 'not_numeric_text',
          totals: 'not_numeric_text',
        },
      },
    },
    category: 'cap_table',
    category_label: 'Cap Table',
  },
  initial_note_conversion_price: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['content_card', 'list'],
        incompatible: {
          bar_chart: 'no_firm_total',
          line_chart: 'no_firm_total',
          pie_chart: 'no_firm_total',
          totals: 'no_firm_total',
        },
      },
    },
    category: 'cap_table',
    category_label: 'Cap Table',
    format_hint: 'currency',
  },
  initial_note_expected_shares: {
    kind: 'count',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'cap_table',
    category_label: 'Cap Table',
    format_hint: 'integer',
  },
  initial_note_issuance_date: {
    kind: 'date',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: ['bar_chart', 'line_chart', 'pie_chart'],
        incompatible: {},
      },
      measure: {
        compatible: ['content_card'],
        incompatible: {
          bar_chart: 'not_numeric_date',
          line_chart: 'not_numeric_date',
          list: 'not_numeric_date',
          pie_chart: 'not_numeric_date',
          totals: 'not_numeric_date',
        },
      },
    },
    category: 'cap_table',
    category_label: 'Cap Table',
  },
  initial_round_date: {
    kind: 'date',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: ['bar_chart', 'line_chart', 'pie_chart'],
        incompatible: {},
      },
      measure: {
        compatible: ['content_card'],
        incompatible: {
          bar_chart: 'not_numeric_date',
          line_chart: 'not_numeric_date',
          list: 'not_numeric_date',
          pie_chart: 'not_numeric_date',
          totals: 'not_numeric_date',
        },
      },
    },
    category: 'cap_table',
    category_label: 'Cap Table',
  },
  intangibles: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  interest_expense: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  inventory: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  invested_capital: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'ownership',
    category_label: 'Ownership',
    format_hint: 'currency',
  },
  last_finalized_at: {
    kind: 'date',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: ['bar_chart', 'line_chart', 'pie_chart'],
        incompatible: {},
      },
      measure: {
        compatible: ['content_card'],
        incompatible: {
          bar_chart: 'not_numeric_date',
          line_chart: 'not_numeric_date',
          list: 'not_numeric_date',
          pie_chart: 'not_numeric_date',
          totals: 'not_numeric_date',
        },
      },
    },
    category: 'identity',
    category_label: 'Identity',
  },
  loan_value: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'ownership',
    category_label: 'Ownership',
    format_hint: 'currency',
  },
  long_term_debt: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  ltm_date: {
    kind: 'date',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: ['bar_chart', 'line_chart', 'pie_chart'],
        incompatible: {},
      },
      measure: {
        compatible: ['content_card'],
        incompatible: {
          bar_chart: 'not_numeric_date',
          line_chart: 'not_numeric_date',
          list: 'not_numeric_date',
          pie_chart: 'not_numeric_date',
          totals: 'not_numeric_date',
        },
      },
    },
    category: 'financials',
    category_label: 'Financials',
  },
  measurement_date: {
    kind: 'date',
    compatibility: {
      column: {
        compatible: [],
        incompatible: {
          table: 'axis_only',
        },
      },
      dimension: {
        compatible: ['bar_chart', 'line_chart', 'pie_chart'],
        incompatible: {},
      },
      measure: {
        compatible: [],
        incompatible: {
          bar_chart: 'axis_only',
          content_card: 'axis_only',
          line_chart: 'axis_only',
          list: 'axis_only',
          pie_chart: 'axis_only',
          totals: 'axis_only',
        },
      },
    },
    category: 'axis',
    category_label: 'Chart Axes',
  },
  moic: {
    kind: 'multiple',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'content_card', 'list'],
        incompatible: {
          pie_chart: 'not_additive_pie',
        },
      },
    },
    category: 'valuation_allocation',
    category_label: 'Valuation & Allocation',
    format_hint: 'multiplier',
  },
  most_recent_investment_date: {
    kind: 'date',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: ['bar_chart', 'line_chart', 'pie_chart'],
        incompatible: {},
      },
      measure: {
        compatible: ['content_card'],
        incompatible: {
          bar_chart: 'not_numeric_date',
          line_chart: 'not_numeric_date',
          list: 'not_numeric_date',
          pie_chart: 'not_numeric_date',
          totals: 'not_numeric_date',
        },
      },
    },
    category: 'ownership',
    category_label: 'Ownership',
  },
  most_recent_round_date: {
    kind: 'date',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: ['bar_chart', 'line_chart', 'pie_chart'],
        incompatible: {},
      },
      measure: {
        compatible: ['content_card'],
        incompatible: {
          bar_chart: 'not_numeric_date',
          line_chart: 'not_numeric_date',
          list: 'not_numeric_date',
          pie_chart: 'not_numeric_date',
          totals: 'not_numeric_date',
        },
      },
    },
    category: 'cap_table',
    category_label: 'Cap Table',
  },
  net_cash_flows: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'cash_flows',
    category_label: 'Cash Flows',
    format_hint: 'currency',
  },
  net_income: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  net_profit_margin: {
    kind: 'percent',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'content_card', 'list'],
        incompatible: {
          pie_chart: 'not_additive_pie',
        },
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'percent',
    percent_scaled: true,
  },
  ntm_adjusted_ebitda: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  ntm_adjusted_ebitda_margin: {
    kind: 'percent',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'content_card', 'list'],
        incompatible: {
          pie_chart: 'not_additive_pie',
        },
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'percent',
    percent_scaled: true,
  },
  ntm_amortization_expense: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  ntm_cost_of_sales_percent: {
    kind: 'percent',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'content_card', 'list'],
        incompatible: {
          pie_chart: 'not_additive_pie',
        },
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'percent',
    percent_scaled: true,
  },
  ntm_date: {
    kind: 'date',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: ['bar_chart', 'line_chart', 'pie_chart'],
        incompatible: {},
      },
      measure: {
        compatible: ['content_card'],
        incompatible: {
          bar_chart: 'not_numeric_date',
          line_chart: 'not_numeric_date',
          list: 'not_numeric_date',
          pie_chart: 'not_numeric_date',
          totals: 'not_numeric_date',
        },
      },
    },
    category: 'financials',
    category_label: 'Financials',
  },
  ntm_depreciation_expense: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  ntm_ebit: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  ntm_ebitda: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  ntm_ebitda_margin: {
    kind: 'percent',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'content_card', 'list'],
        incompatible: {
          pie_chart: 'not_additive_pie',
        },
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'percent',
    percent_scaled: true,
  },
  ntm_gross_margin: {
    kind: 'percent',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'content_card', 'list'],
        incompatible: {
          pie_chart: 'not_additive_pie',
        },
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'percent',
    percent_scaled: true,
  },
  ntm_gross_profit: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  ntm_income_taxes: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  ntm_interest_expense: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  ntm_net_income: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  ntm_net_profit_margin: {
    kind: 'percent',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'content_card', 'list'],
        incompatible: {
          pie_chart: 'not_additive_pie',
        },
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'percent',
    percent_scaled: true,
  },
  ntm_operating_expenses: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  ntm_operating_percent_of_sales: {
    kind: 'percent',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'content_card', 'list'],
        incompatible: {
          pie_chart: 'not_additive_pie',
        },
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'percent',
    percent_scaled: true,
  },
  ntm_other_expense: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  ntm_pretax_income: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  ntm_revenue_growth_rate: {
    kind: 'percent',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'content_card', 'list'],
        incompatible: {
          pie_chart: 'not_additive_pie',
        },
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'percent',
    percent_scaled: true,
  },
  ntm_total_cost_of_sales: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  ntm_total_revenue: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  operating_expenses: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  operating_percent_of_sales: {
    kind: 'percent',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'content_card', 'list'],
        incompatible: {
          pie_chart: 'not_additive_pie',
        },
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'percent',
    percent_scaled: true,
  },
  option_pool_percent: {
    kind: 'percent',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'content_card', 'list'],
        incompatible: {
          pie_chart: 'not_additive_pie',
        },
      },
    },
    category: 'cap_table',
    category_label: 'Cap Table',
    format_hint: 'percent',
    percent_scaled: true,
  },
  other_current_assets: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  other_current_liabilities: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  other_expense: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  other_long_term_assets: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  other_long_term_debt: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  outstanding_ownership: {
    kind: 'percent',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'content_card', 'list'],
        incompatible: {
          pie_chart: 'not_additive_pie',
        },
      },
    },
    category: 'ownership',
    category_label: 'Ownership',
    format_hint: 'percent',
  },
  pending_document_requests: {
    kind: 'count',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'documents_process_management',
    category_label: 'Documents & Process Management',
    format_hint: 'integer',
  },
  pending_questions: {
    kind: 'count',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'documents_process_management',
    category_label: 'Documents & Process Management',
    format_hint: 'integer',
  },
  percent_change_from_previous: {
    kind: 'percent',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['content_card', 'list'],
        incompatible: {
          bar_chart: 'no_firm_total',
          line_chart: 'no_firm_total',
          pie_chart: 'no_firm_total',
          totals: 'no_firm_total',
        },
      },
    },
    category: 'valuation_allocation',
    category_label: 'Valuation & Allocation',
    format_hint: 'percent',
  },
  ppe: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  pretax_income: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  proceeds_from_shares_sold: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'ownership',
    category_label: 'Ownership',
    format_hint: 'currency',
  },
  projected_revenue_year_1: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  projected_revenue_year_2: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  projected_revenue_year_3: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  realized_value: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'ownership',
    category_label: 'Ownership',
    format_hint: 'currency',
  },
  referenced_documents: {
    kind: 'count',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'documents_process_management',
    category_label: 'Documents & Process Management',
    format_hint: 'integer',
  },
  revenue_growth_rate: {
    kind: 'percent',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'content_card', 'list'],
        incompatible: {
          pie_chart: 'not_additive_pie',
        },
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'percent',
    percent_scaled: true,
  },
  short_term_debt: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  specific_preference: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'ownership',
    category_label: 'Ownership',
    format_hint: 'currency',
  },
  total_assets: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  total_common_shares: {
    kind: 'count',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'cap_table',
    category_label: 'Cap Table',
    format_hint: 'integer',
  },
  total_company_preference: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'cap_table',
    category_label: 'Cap Table',
    format_hint: 'currency',
  },
  total_cost_of_sales: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  total_current_assets: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  total_current_liabilities: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  total_documents: {
    kind: 'count',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'documents_process_management',
    category_label: 'Documents & Process Management',
    format_hint: 'integer',
  },
  total_fully_diluted_preferred_shares: {
    kind: 'count',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'cap_table',
    category_label: 'Cap Table',
    format_hint: 'integer',
  },
  total_fully_diluted_shares: {
    kind: 'count',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'cap_table',
    category_label: 'Cap Table',
    format_hint: 'integer',
  },
  total_initial_liquidation_preference: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'cap_table',
    category_label: 'Cap Table',
    format_hint: 'currency',
  },
  total_insight_preference: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'ownership',
    category_label: 'Ownership',
    format_hint: 'currency',
  },
  total_liabilities: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  total_liabilities_and_equity: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  total_long_term_assets: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  total_long_term_debt: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  total_note_expected_shares: {
    kind: 'count',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'cap_table',
    category_label: 'Cap Table',
    format_hint: 'integer',
  },
  total_options: {
    kind: 'count',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'cap_table',
    category_label: 'Cap Table',
    format_hint: 'integer',
  },
  total_other_capital_costs: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'cash_flows',
    category_label: 'Cash Flows',
    format_hint: 'currency',
  },
  total_outstanding_preferred_shares: {
    kind: 'count',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'cap_table',
    category_label: 'Cap Table',
    format_hint: 'integer',
  },
  total_outstanding_shares: {
    kind: 'count',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'cap_table',
    category_label: 'Cap Table',
    format_hint: 'integer',
  },
  total_preference_with_dividends: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'cap_table',
    category_label: 'Cap Table',
    format_hint: 'currency',
  },
  total_preferred_rounds: {
    kind: 'count',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'cap_table',
    category_label: 'Cap Table',
    format_hint: 'integer',
  },
  total_raised: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'cap_table',
    category_label: 'Cap Table',
    format_hint: 'currency',
  },
  total_revenue: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'financials',
    category_label: 'Financials',
    format_hint: 'currency',
  },
  total_unissued_options: {
    kind: 'count',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'cap_table',
    category_label: 'Cap Table',
    format_hint: 'integer',
  },
  total_value: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'valuation_allocation',
    category_label: 'Valuation & Allocation',
    format_hint: 'currency',
  },
  total_warrants: {
    kind: 'count',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'cap_table',
    category_label: 'Cap Table',
    format_hint: 'integer',
  },
  unrealized_value: {
    kind: 'money',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'continuous_dimension',
          line_chart: 'continuous_dimension',
          pie_chart: 'continuous_dimension',
        },
      },
      measure: {
        compatible: ['totals', 'bar_chart', 'line_chart', 'pie_chart', 'content_card', 'list'],
        incompatible: {},
      },
    },
    category: 'valuation_allocation',
    category_label: 'Valuation & Allocation',
    format_hint: 'currency',
  },
  uses_custom_breakpoints: {
    kind: 'boolean',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: ['bar_chart', 'pie_chart'],
        incompatible: {
          line_chart: 'unordered_axis_line',
        },
      },
      measure: {
        compatible: ['content_card'],
        incompatible: {
          bar_chart: 'not_numeric_boolean',
          line_chart: 'not_numeric_boolean',
          list: 'not_numeric_boolean',
          pie_chart: 'not_numeric_boolean',
          totals: 'not_numeric_boolean',
        },
      },
    },
    category: 'breakpoints',
    category_label: 'Breakpoints',
  },
  valuation_approach: {
    kind: 'text',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: ['bar_chart', 'pie_chart'],
        incompatible: {
          line_chart: 'unordered_axis_line',
        },
      },
      measure: {
        compatible: ['content_card'],
        incompatible: {
          bar_chart: 'not_numeric_text',
          line_chart: 'not_numeric_text',
          list: 'not_numeric_text',
          pie_chart: 'not_numeric_text',
          totals: 'not_numeric_text',
        },
      },
    },
    category: 'valuation_allocation',
    category_label: 'Valuation & Allocation',
  },
  valuation_is_final: {
    kind: 'boolean',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: ['bar_chart', 'pie_chart'],
        incompatible: {
          line_chart: 'unordered_axis_line',
        },
      },
      measure: {
        compatible: ['content_card'],
        incompatible: {
          bar_chart: 'not_numeric_boolean',
          line_chart: 'not_numeric_boolean',
          list: 'not_numeric_boolean',
          pie_chart: 'not_numeric_boolean',
          totals: 'not_numeric_boolean',
        },
      },
    },
    category: 'valuation_allocation',
    category_label: 'Valuation & Allocation',
  },
  valuation_is_published: {
    kind: 'boolean',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: ['bar_chart', 'pie_chart'],
        incompatible: {
          line_chart: 'unordered_axis_line',
        },
      },
      measure: {
        compatible: ['content_card'],
        incompatible: {
          bar_chart: 'not_numeric_boolean',
          line_chart: 'not_numeric_boolean',
          list: 'not_numeric_boolean',
          pie_chart: 'not_numeric_boolean',
          totals: 'not_numeric_boolean',
        },
      },
    },
    category: 'valuation_allocation',
    category_label: 'Valuation & Allocation',
  },
  valuation_methods: {
    kind: 'list',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: [],
        incompatible: {
          bar_chart: 'multi_valued_dimension',
          line_chart: 'multi_valued_dimension',
          pie_chart: 'multi_valued_dimension',
        },
      },
      measure: {
        compatible: ['content_card'],
        incompatible: {
          bar_chart: 'not_numeric_list',
          line_chart: 'not_numeric_list',
          list: 'not_numeric_list',
          pie_chart: 'not_numeric_list',
          totals: 'not_numeric_list',
        },
      },
    },
    category: 'valuation_allocation',
    category_label: 'Valuation & Allocation',
  },
  valuation_status: {
    kind: 'text',
    compatibility: {
      column: {
        compatible: ['table'],
        incompatible: {},
      },
      dimension: {
        compatible: ['bar_chart', 'pie_chart'],
        incompatible: {
          line_chart: 'unordered_axis_line',
        },
      },
      measure: {
        compatible: ['content_card'],
        incompatible: {
          bar_chart: 'not_numeric_text',
          line_chart: 'not_numeric_text',
          list: 'not_numeric_text',
          pie_chart: 'not_numeric_text',
          totals: 'not_numeric_text',
        },
      },
    },
    category: 'valuation_allocation',
    category_label: 'Valuation & Allocation',
  },
};

/** Reason templates, keyed by the codes used in `incompatible` above. `{label}` is filled in by the caller from its own column label. */
export const DASHBOARD_COMPATIBILITY_REASONS: Readonly<Record<string, string>> = {
  axis_only: '{label} is a chart axis rather than a stored column, so it cannot be measured or shown in a table.',
  continuous_dimension:
    '{label} is a continuous value with a different number on nearly every company, so grouping by it produces one slice per row.',
  multi_valued_dimension: '{label} holds several values per company, so a company would fall into more than one group.',
  no_firm_total: '{label} has no firm-level reading, so a totals card would have nothing to show.',
  not_additive_pie:
    'Pie slices have to add up to the whole, and {label} is a rate or a per-company value rather than an additive amount.',
  not_numeric_boolean:
    '{label} is a yes/no flag, so there is nothing to measure. Use it to group or as a table column instead.',
  not_numeric_date: '{label} is a date, so there is nothing to measure. Use it to group or as a table column instead.',
  not_numeric_list: '{label} holds several values per company, so there is nothing to measure.',
  not_numeric_text: '{label} is text, so there is nothing to measure. Use it to group or as a table column instead.',
  unordered_axis_line: 'A line implies an ordered axis and {label} has no natural order. A bar chart suits it better.',
};

/** Per-metric prose for columns with no firm-level reading, written on the backend in aggregation.py. Preferred over the generic template when present. */
export const DASHBOARD_TOTALS_UNSUPPORTED_REASONS: Readonly<Record<string, string>> = {
  avg_option_strike_price: 'A per-share strike price cannot be added across companies.',
  avg_warrant_strike_price: 'A per-share strike price cannot be added across companies.',
  common_share_value: 'A per-share value cannot be added across companies.',
  company_count:
    'Company count is only populated on fund rows, and adding it across funds double-counts any company held by more than one fund.',
  highest_breakpoint_limit: 'A per-company breakpoint bound has no portfolio-level equivalent.',
  highest_breakpoint_price: 'A per-share breakpoint price cannot be added across companies.',
  implied_ev_kpi:
    "Each company's KPI is measured in its own unit, so there is no common denominator to aggregate across the portfolio.",
  initial_note_conversion_price: 'A per-share conversion price cannot be added across companies.',
  percent_change_from_previous:
    'This is already a per-company change against its own previous valuation. Use a prior-period comparison on the underlying value instead.',
};
